import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import TextLink from '@kiwicom/orbit-components/lib/TextLink';
import ChevronBackward from '@kiwicom/orbit-components/lib/icons/ChevronBackward';
import { useRouter } from 'next/router';
import { log } from '@kiwicom/nitro/lib/services/log/logger';
import { Category, createEventLogUnified, UIAction } from '@/common/services/logging';

const BreadcrumbBackwardNavigation = () => {
  const { pathname } = useRouter();
  const { back } = useRouter();

  const onClick = async () => {
    await log(createEventLogUnified(Category.COMMON, UIAction.BreadcrumbClicked, 'go back'), {
      pathname,
    }).catch();

    back();
  };

  return (
    <TextLink
      onClick={onClick}
      type="secondary"
      size="normal"
      iconLeft={<ChevronBackward reverseOnRtl ariaHidden />}
    >
      <FormattedMessage id="common.back" defaultMessage="Back" />
    </TextLink>
  );
};

export default BreadcrumbBackwardNavigation;
